import React from 'react';

const features = [
  {
    id: 'feat-trivia',
    icon: '🗂️',
    title: 'Case File Trivia',
    description: 'Deep-cut questions testing your episode knowledge, character arcs, and show lore. Not your average quiz.',
    color: 'primary',
  },
  {
    id: 'feat-quote',
    icon: '💬',
    title: 'Quote or Not',
    description: 'Did the character actually say that? Authentic quotes mixed with convincing fakes. Trust no one.',
    color: 'secondary',
  },
  {
    id: 'feat-observation',
    icon: '🔮',
    title: 'Psychic Observation',
    description: 'Study a scene screenshot, then answer questions from memory. Your observation skills are on trial.',
    color: 'primary',
  },
  {
    id: 'feat-pineapple',
    icon: '🍍',
    title: 'Pineapple Hunt',
    description: 'Find hidden pineapples in scene images. Fans who know the show know exactly what to look for.',
    color: 'secondary',
  },
  {
    id: 'feat-car',
    icon: '🚙',
    title: 'Blueberry Challenge',
    description: 'Speed rounds. Rapid fire. Identify vehicles, locations, and props before the clock runs out.',
    color: 'primary',
  },
  {
    id: 'feat-popculture',
    icon: '📺',
    title: 'Pop Culture Recall',
    description: 'Cross-reference your knowledge of 80s references, music, and cultural touchstones woven into the show.',
    color: 'secondary',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-24 px-6 max-w-screen-xl mx-auto">
      <div className="text-center mb-16">
        <p className="text-xs font-semibold uppercase tracking-widest text-primary mb-3">Game Categories</p>
        <h2 className="text-hero-md font-extrabold text-foreground mb-4">
          Seven Ways to Prove<br />
          <span className="gradient-text-primary">You&apos;re the Ultimate Fan</span>
        </h2>
        <p className="text-muted-foreground text-lg max-w-xl mx-auto">
          Each Fan world comes with multiple competitive game formats. Master them all to reach the top rank.
        </p>
        <div className="flex items-center gap-3 max-w-xl mx-auto mt-4">
          <div className="flex-1 h-px bg-blue-300/50"></div>
          <span className="text-blue-300 text-sm font-medium whitespace-nowrap">Some Examples from Psych</span>
          <div className="flex-1 h-px bg-blue-300/50"></div>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
        {features?.map((feat) => (
          <div
            key={feat?.id}
            className={`bg-card border border-border rounded-2xl p-6 hover:border-${feat?.color}/40 hover:bg-${feat?.color}/5 transition-all duration-200 group cursor-default`}
          >
            <div className={`w-12 h-12 rounded-xl bg-${feat?.color}/10 border border-${feat?.color}/20 flex items-center justify-center text-2xl mb-4 group-hover:scale-110 transition-transform duration-200`}>
              {feat?.icon}
            </div>
            <h3 className="text-base font-bold text-foreground mb-2">{feat?.title}</h3>
            <p className="text-sm text-muted-foreground leading-relaxed">{feat?.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
}